{
  "fr": {
    "textEditor": {
      "editKinds": {
        "help_me_write": "Aide à la rédaction",
        "spellcheck": "Orthographe",
        "summarize": "Résumé",
        "translate": "Traduire un texte"
      },
      "headers": {
        "aiTextModal": "Assistants IA : {title}"
      },
      "hints": {
        "loadingDocument": "Chargement du document...",
        "noTextSelected": "Aucun texte sélectionné",
        "progressMessage": "En cours de traitement...",
        "prompt": "Par exemple : <strong>Régions en Allemagne</strong> ou <strong>Rome antique</strong>"
      },
      "labels": {
        "content": "Contenu du texte"
      },
      "links": {
        "helpMeWrite": "Aide-moi à écrire",
        "spellcheck": "Corriger l'orthographe et la grammaire",
        "summarize": "Créer un résumé",
        "translate": "Traduire un texte"
      },
      "placeholder": "Créez des textes collaboratifs avec différents contenus multimédias tels que du texte formaté, des images et des liens externes.",
      "placeholders": {
        "aiPromptModal": "Saisir un sujet..."
      }
    }
  }
}
